export default __webpack_public_path__ + "static/imobi-fluxo-6e09c19c6e61e2eefa922224ae6fb861.png";